const BASE_URL = "https://jeevixa-backend.onrender.com";

export default BASE_URL;